export default import.meta.ROLLUP_FILE_URL_4h4mPYFc;